import React, { useState } from "react";
import AddFilesIcon from "../../assets/icons/AddFilesIcon";
import { errorToast } from "../../utils/methods/toast";
import styles from "./FileUpload.module.scss"; // Предполагается, что вы создадите отдельный CSS модуль
import { useDispatch, useSelector } from "react-redux";
import { setActiveAssistant, setNewAssistant } from "../../store/slices/assistantSlice";

export const FileUpload = ({
  acceptedFileType = "application/json",
  fileTypeErrorMessage = "Неподдерживаемый файл! \n Выберите другой",
  inputId = "file_upload",
  icon = <AddFilesIcon size={25} />,
  mainLabel = "JSON-ключ",
  subLabel = "Нажмите или перетащите файл сюда",
  onFileSelected,
}) => {
  const dispatch = useDispatch();
  const activeAssistant = useSelector((state) => state.assistant.activeAssistant);
  const newAssistant = useSelector((state) => state.assistant.newAssistant);

  const [dragging, setDragging] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type === acceptedFileType) {
      if (onFileSelected) {
        onFileSelected(selectedFile);
      } else if (selectedFile.type === "application/json") {
        if (activeAssistant) {
          const updatedAssistant = {
            ...activeAssistant,
            driveFile: selectedFile,
          };
          dispatch(setActiveAssistant(updatedAssistant));
        } else if (newAssistant) {
          const updatedAssistant = {
            ...newAssistant,
            driveFile: selectedFile,
          };
          dispatch(setNewAssistant(updatedAssistant));
        }
      } else {
        if (activeAssistant) {
          const updatedAssistant = {
            ...activeAssistant,
            files: [...(activeAssistant?.files || []), selectedFile],
          };
          dispatch(setActiveAssistant(updatedAssistant));
        } else if (newAssistant) {
          const updatedAssistant = {
            ...newAssistant,
            files: [...(newAssistant?.files || []), selectedFile],
          };
          dispatch(setNewAssistant(updatedAssistant));
        }
      }
    } else if (selectedFile) {
      errorToast(fileTypeErrorMessage);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && droppedFile.type === acceptedFileType) {
      if (onFileSelected) {
        onFileSelected(droppedFile);
      } else {
        const assistant = activeAssistant || newAssistant;
        if (assistant) {
          let updatedAssistant = { ...assistant };
          if (!updatedAssistant.settings) updatedAssistant.settings = {};
          if (!Array.isArray(updatedAssistant.files)) updatedAssistant.files = [];
          updatedAssistant.files.push(droppedFile);
          if (activeAssistant) {
            dispatch(setActiveAssistant(updatedAssistant));
          } else {
            dispatch(setNewAssistant(updatedAssistant));
          }
        }
      }
    } else if (droppedFile && droppedFile?.type !== acceptedFileType) {
      errorToast(fileTypeErrorMessage);
    }
  };

  return (
    <label
      className={
        dragging
          ? `${styles.addFilesInput} ${styles.dragging}`
          : styles.addFilesInput
      }
      htmlFor={inputId}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <div className={styles.fileInfo}>
        {icon}
        <span className={styles.addFilesString}>{mainLabel}</span>
        <span
          className={styles.addFilesString}
          style={{ fontWeight: "400", fontSize: "14px" }}
        >
          {subLabel}
        </span>
      </div>
      <input
        type="file"
        className={styles.inputFile}
        id={inputId}
        accept={
          acceptedFileType === "application/json" ? ".json" : acceptedFileType
        }
        onChange={handleFileChange}
      />
    </label>
  );
};
